/* unplugin-vue-components disabled */import { render } from "./routetype.vue?vue&type=template&id=0f833bc6&scoped=true"
import script from "./routetype.vue?vue&type=script&lang=js"
export * from "./routetype.vue?vue&type=script&lang=js"

import "./routetype.vue?vue&type=style&index=0&id=0f833bc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f833bc6"]])

export default __exports__